import { ObjectHelper } from "../../../../../apps/idl/src/helpers/objectHelper";

export class WorkspaceSelectionCancelledError extends Error {

	constructor() {
		super("User cancelled workspace selection.");
		// Nécessaire pour que le 'instanceof WorkspaceSelectionCancelledError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, WorkspaceSelectionCancelledError);
	}
}